var React = require('react');

function Embed (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15 13.8334L18.3333 10.5001L15 7.16675","stroke":"#262AC5","strokeWidth":"1.67","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M5.0013 7.16675L1.66797 10.5001L5.0013 13.8334","stroke":"#262AC5","strokeWidth":"1.67","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M12.0846 3.83325L7.91797 17.1666","stroke":"#262AC5","strokeWidth":"1.67","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Embed.defaultProps = {"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none"};

module.exports = Embed;

Embed.default = Embed;
